export enum PractitionerEdit {
  Bio = 'bio',
  Business = 'business',
  Conditions = 'conditions',
  Experience = 'experience',
  Personal = 'personal',
  Photo = 'photo',
  Specialties = 'specialties'
}
